import styled, { css } from "styled-components";
import Colors from "./../../../../global/color";
import { reset, mixFont } from "./../../../../global/mixins";
import { Link as StyledLink } from "./../../../../makealist/components/StyledLink";

const Constants = {
  avatar: {
    size: 80,
    margin: 22,
    image: {
      size: 70
    },
    border: {
      size: 2,
      color: Colors.gold
    }
  },
  hero: {
    height: 375,
    size: {
      width: 265,
      height: 300
    },
    margin: {
      bottom: 12
    }
  },
  author: {
    font: {
      family: "FuturaPT-Book",
      size: 16,
      height: 22,
      color: "black"
    },
    name: {
      color: "black"
    },
    role: {
      color: Colors.slate
    },
    heading: {
      size: 12,
      height: 24,
      color: Colors.gold,
      family: "FuturaPT-Book",
      margin: 23,
      spacing: 3
    },
    title: {
      size: 20,
      family: "FuturaPT-Book",
      color: "black",
      height: 26,
      margin: {
        bottom: 22,
        top: 30
      }
    }
  }
};

export const Wrapper = styled.div`
  ${({ fixed }) =>
    fixed
      ? css`
          max-width: ${Constants.hero.size.width}px;
        `
      : ""}
`;

export const Hero = styled.div`
  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
  width: 100%;
  min-height: ${({ hero }) => (hero ? "calc(100vh - 170px)" : "auto")};
  /* display: flex; */
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
`;

export const HeroBackground = styled.div`
  flex: 1;
  /* display: flex; */
  img {
    flex: 1;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

export const HeroHeading = styled.div`
  ${reset};
  ${mixFont(Constants.author.heading)}
  text-transform: uppercase;
  position: relative;
  margin-top: ${Constants.author.heading.margin}px;
`;

export const HeroTitle = styled.div`
  ${reset};
  ${mixFont(Constants.author.title)}
  position: relative;
  margin-bottom: ${Constants.author.title.margin.bottom}px;
  margin-top: ${({ noName }) =>
    noName ? Constants.author.title.margin.top : 0}px;
  ${StyledLink}:hover & {
    text-decoration: underline;
    text-decoration-color: ${Colors.goldLight};
  }
`;

export const Author = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  ${mixFont(Constants.author.font)}
`;

export const AuthorName = styled.h1`
  ${reset}
  color: ${Constants.author.name.color};
`;

export const AuthorRole = styled.h2`
  ${reset}
  color: ${Constants.author.role.color};
`;
